import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';

export function getAllSports(sessionId) {
    return dispatch => {
        dispatch(fetching());
        const service = new FantasyLabsService();
        service.getAllSports(sessionId, err => dispatch(failed(err)), json => dispatch(success(json)));
    };
}

function fetching() {
    return {
        type: actionTypes.SPORTS_FETCHING
    };
}

function success(json) {
    return {
        type: actionTypes.SPORTS_SUCCESS,
        sports: json === null || json.sports === null ? [] : json.sports
    };
}

function failed(err) {
    return {
        type: actionTypes.SPORTS_FAILED,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/sports.js